import { ApiService }        from '../../app-lite/api/api.service';
import { CompanyMessagesModel } from '../../app-lite/companies/models/company.messages';
import { TableService }         from '../../app-lite/table/table.service';

import InspectionGroupHtml     from '../../app-lite/inspections/inspection.group.html';
import InspectionGroupsHtml    from '../../app-lite/inspections/inspection.groups.html';
import InspectionHtml          from './inspection.html';
import InspectionListHtml      from './inspection.list.html';
import InspectionSettingsHtml  from './inspection.settings.html';
import InspectionTemplateHtml  from '../../app-lite/inspections/inspection.template.html';
import InspectionTemplatesHtml from '../../app-lite/inspections/inspection.templates.html';

export function InspectionsStates (
  $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller  : 'InspectionSettingsCtrl',
    controllerAs: 'inspection',
    name        : 'app.inspection-settings',
    params      : {
      activated: { squash: true, value: null }
    },
    templateUrl: InspectionSettingsHtml,
    url        : '/inspection/settings/:activated',
    resolve    : {
      settings: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/inspection_setting')
    }
  })
  .state({
    controller : 'InspectionListCtrl',
    name       : 'app.inspection-list',
    templateUrl: InspectionListHtml,
    url        : '/inspection/list/:key',
    resolve    : {
      inspections: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService, INSPECTIONKEYS : any) : ng.IPromise<any> => workshopAPI.get(`/dashboard/${INSPECTIONKEYS[$stateParams.key].route}`,
        [
          10,
          0,
          INSPECTIONKEYS[$stateParams.key].sorting.field,
          INSPECTIONKEYS[$stateParams.key].sorting.direction
        ])
    }
  })
  .state({
    controller  : 'InspectionCtrl',
    controllerAs: 'inspection',
    name        : 'app.inspection',
    params      : {
      customer_id: { squash: true, value: null },
      id         : { squash: true, value: null },
      vehicle_id : { squash: true, value: null }
    },
    templateUrl: InspectionHtml,
    url        : '/:customer_id/:vehicle_id/inspection/:id',
    resolve    : {
      company        : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company'),
      companyMessages: ( $rootScope : any ) : ng.IPromise<CompanyMessagesModel> => $rootScope.Company.getDefaultMessages(),
      groups         : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/inspection_groups'),
      attachments    : ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> =>
        $stateParams.id
          ? workshopAPI.get('/inspection/list_attachments', $stateParams.id)
          : [],
      customer: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | object =>
        $stateParams.customer_id
          ? workshopAPI.get('/customer', $stateParams.customer_id)
          : {
            cash_or_account: 'C',
            customer_type  : 'C',
            price_type     : '1'
          },
      inspection: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | object =>
        $stateParams.id
          ? workshopAPI.get('/inspection', $stateParams.id)
          : $stateParams.customer_id
            ? { template_id: '07e678a0-fe0d-11e6-862f-fb2f5c7423fb' }
            : {},
      inspection_products: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> =>
        $stateParams.id
          ? workshopAPI.get('/inspection_item_products', [$stateParams.id, 0, '*', 'item_code', 'asc'])
          : [],
      templates: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | Array<any> =>
        $stateParams.customer_id
          ? workshopAPI.get('/inspection_templates', [0, '*', 'name', 'asc'])
          : [],
      settings: ( $q : ng.IQService, workshopAPI : ApiService ) : ng.IPromise<any> => $q.all({
        settings: workshopAPI.get('/inspection_setting'),
        statuses: workshopAPI.get('/system/inspection_status_types', null, null, {
          bypass: true
        })
      }).then(responses => Object.assign({}, responses.settings, { statuses: responses.statuses })),
      vehicle: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | object =>
        $stateParams.vehicle_id
          ? workshopAPI.get('/vehicle', $stateParams.vehicle_id)
          : $stateParams.customer_id
            ? { customer_id: $stateParams.customer_id }
            : {}
    }
  })
  .state({
    controller : 'InspectionGroupsCtrl',
    name       : 'app.inspection-groups',
    templateUrl: InspectionGroupsHtml,
    url        : '/inspection/groups',
    resolve    : {
      groups: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/inspection_groups')
    }
  })
  .state({
    controller: 'InspectionGroupCtrl',
    name      : 'app.inspection-group',
    params    : {
      id: { squash: true, value: null }
    },
    templateUrl: InspectionGroupHtml,
    url        : '/inspection/group/:id',
    resolve    : {
      group: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | object =>
        $stateParams.id
          ? workshopAPI.get('/inspection_group', $stateParams.id)
          : {}
    }
  })
  .state({
    controller : 'InspectionTemplatesCtrl',
    name       : 'app.inspection-templates',
    templateUrl: InspectionTemplatesHtml,
    url        : '/inspection/templates',
    resolve    : {
      templates: ( tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> => {
        const cache = tableApi.getCacheForTable('templates');

        return workshopAPI.get('/inspection_templates', [
          0,
          cache.paging.pageSize   || 11,
          cache.sorting.field     || 'name',
          cache.sorting.direction || 'asc'
        ]);
      }
    }
  })
  .state({
    controller  : 'InspectionTemplateCtrl',
    controllerAs: 'inspection',
    name        : 'app.inspection-template',
    params      : {
      id: { squash: true, value: null }
    },
    templateUrl: InspectionTemplateHtml,
    url        : '/inspection/template/:id',
    resolve    : {
      groups  : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/inspection_groups'),
      template: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | object =>
        $stateParams.id
          ? workshopAPI.get('/inspection_template', $stateParams.id)
          : {},
      types: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/inspection_types')
    }
  });
};